import { render } from "./Committees.vue?vue&type=template&id=922cd132&scoped=true"
import script from "./Committees.vue?vue&type=script&lang=js"
export * from "./Committees.vue?vue&type=script&lang=js"

import "./Committees.vue?vue&type=style&index=0&id=922cd132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922cd132"]])

export default __exports__